import type { Material } from '#domain/Material.ts';

import type { ChargingDetails } from './ChargingDetails.ts';
import type { Location } from './Location.ts';
import type { StopStatus } from './StopStatus.ts';

export type StopType = 'load' | 'unload' | 'execute' | 'unknown';

export type Stop = {
    charging?: ChargingDetails;
    clearCharging?: boolean;
    id: string;
    name: string;
    startActual?: string;
    startTarget: string;
    endActual?: string;
    endTarget: string;
    location: Location;
    type: StopType;
    status?: StopStatus;
    comment?: string;
    latitude?: string;
    longitude?: string;
};

export type StopDetails = Stop & {
    materials: Material[];
};

export const isCoordinateOnlyServiceStop = (stop?: Stop) => {
    if (
        stop?.type !== 'execute' ||
        [stop.location.street, stop.location.city, stop.location.zipCode, stop.location.country].some(value =>
            value.trim()
        )
    ) {
        return false;
    }

    const latitude = stop.latitude?.trim() ? Number(stop.latitude) : Number.NaN;
    const longitude = stop.longitude?.trim() ? Number(stop.longitude) : Number.NaN;
    return (
        Number.isFinite(latitude) &&
        Math.abs(latitude) <= 90 &&
        Number.isFinite(longitude) &&
        Math.abs(longitude) <= 180
    );
};
